import React, { useMemo } from "react";
import { RuleGroupType } from "@common/types/transactionRule";
import { KICK_GROUP_ICON } from "@common/constants/rules";
import { Picker } from "@design-system/Picker/Picker.lib";
import { useWorkspaceRuleGroupsList } from "@api/rules.api";
import styles from "./ActionsCard.module.scss";

interface Props {
    value: string;
    onChange: (groupId: string) => void;
    groupType?: RuleGroupType;
}

export const RuleGroupSelect: React.FC<Props> = ({
    value,
    onChange,
    groupType = RuleGroupType.TRANSACTION,
}) => {
    const ruleGroupsList = useWorkspaceRuleGroupsList();

    const filteredGroups = useMemo(
        () =>
            (ruleGroupsList.data ?? []).filter(
                (g) => g.type === groupType && g.icon !== KICK_GROUP_ICON, // skip system group
            ),
        [ruleGroupsList.data, groupType],
    );

    const items = useMemo(
        () =>
            filteredGroups.map((g) => ({
                value: g.id,
                label: g.name,
            })),
        [filteredGroups],
    );

    return (
        <div className={styles.ruleGroupSelect}>
            <span className={styles.ruleGroupLabel}>Rule group</span>
            <Picker.Select
                items={items}
                value={value || null}
                onValueChange={(groupId) => {
                    if (groupId) {
                        onChange(groupId);
                    }
                }}
                placeholder="Select group"
            />
        </div>
    );
};
